import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Breadcrumbs, Grid, Typography } from "@material-ui/core";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import OverviewStyles from "pages/NftDep/Auction/OverviewStyles";
import {
  setCurrentPage,
} from "actions";
import * as C from "components";
import UsersTable from "components/Admin/UsersTable";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    position: "-webkit-sticky",
    position: "sticky",
    top: 0,
    zIndex: 1000,
  },
  fillRemailSpace: {
    flex: "auto",
  },
  sectionTop: {
    marginTop: -16,
    marginBottom: 8,
    [theme.breakpoints.down("sm")]: {
      marginTop: 8,
    },
  },
  breadcrumbs: {
    marginTop: 16,
    minHeight: 30,
  },
}));

const AdminUsers = ({
  setCurrentPage,
  pageTopLoader,
}) => {
  const classes = useStyles();

  useEffect(() => {
    setCurrentPage(window.location.pathname);
  }, []);

  return (
    <C.ContentWrapper>
      <Grid
        container
        direction="row"
        className={classes.sectionTop}
        justifyContent="space-between"
      >
        <Grid item>
          <Breadcrumbs separator="›" className={classes.breadcrumbs}>
            <Typography>ADMIN</Typography>
            <Typography variant="body1">ユーザー管理</Typography>
          </Breadcrumbs>
        </Grid>
        <Grid item className={classes.fillRemailSpace}></Grid>
        <Grid item>
        </Grid>
      </Grid>

      <Grid
        container
        spacing={1}
        direction="row"
        style={{ marginTop: 16, marginRight: 16, marginBottom: 8 }}
        justifyContent="center"
        alignItems="center"
      >
        <Grid item xs={12} md={12} lg={11} style={{ marginTop: 0, justifyContent: "center" }}>
          <UsersTable />
        </Grid>
      </Grid>
    </C.ContentWrapper>
  );
};

AdminUsers.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  loading: state.nftDep.loading,
  pageTopLoader: state.page.pageTopLoader,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (param) => dispatch(setCurrentPage(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(OverviewStyles, { withTheme: true })(AdminUsers));
